import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon, CreditCardIcon } from 'lucide-react';
import { ScrollReveal } from './ScrollReveal';
export function PricingCard() {
  const [showBankDetails, setShowBankDetails] = useState(false);
  return <section id="pricing" className="py-24 px-6 bg-white" data-id="element-85">
      <div className="max-w-4xl mx-auto" data-id="element-86">
        <ScrollReveal data-id="element-87">
          <div className="text-center mb-16" data-id="element-88">
            <span className="text-accent font-bold tracking-wider text-sm" data-id="element-89">
              Pricing
            </span>
            <h2 className="text-4xl md:text-5xl font-extrabold text-navy mt-2" data-id="element-90">
              Investment
            </h2>
          </div>
        </ScrollReveal>

        <ScrollReveal direction="up" data-id="element-91">
          <div className="bg-white rounded-2xl shadow-xl border-t-4 border-accent overflow-hidden relative" data-id="element-92">
            <div className="p-8 md:p-12" data-id="element-93">
              <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-8" data-id="element-94">
                <div data-id="element-95">
                  <h3 className="text-2xl font-bold text-navy" data-id="element-96">
                    Brand MVB package
                  </h3>
                  <span className="inline-block mt-2 px-3 py-1 bg-gray-100 text-gray-600 text-xs font-bold tracking-wider rounded-full" data-id="element-97">
                    Fixed price
                  </span>
                </div>
                <div className="mt-4 md:mt-0 text-right" data-id="element-98">
                  <div className="text-5xl font-extrabold text-navy" data-id="element-99">
                    £1,800
                  </div>
                  <div className="text-gray-500 font-medium mt-1" data-id="element-100">
                    4 weeks timeline
                  </div>
                </div>
              </div>

              <div className="w-full h-px bg-gray-100 my-8" data-id="element-101" />

              <div className="space-y-6" data-id="element-102">
                <h4 className="text-sm font-bold text-gray-400 tracking-wider" data-id="element-103">
                  Payment schedule
                </h4>

                <div className="flex items-center justify-between p-4 bg-offwhite rounded-lg border border-gray-100" data-id="element-104">
                  <div className="flex items-center" data-id="element-105">
                    <div className="w-8 h-8 rounded-full bg-green-100 flex items-center justify-center mr-4" data-id="element-106">
                      <span className="text-green-600 font-bold text-sm" data-id="element-107">
                        1
                      </span>
                    </div>
                    <div data-id="element-108">
                      <div className="font-bold text-navy" data-id="element-109">
                        25% deposit (£450)
                      </div>
                      <div className="text-sm text-gray-500" data-id="element-110">
                        Due upon signing
                      </div>
                    </div>
                  </div>
                  <span className="text-xs font-bold text-accent bg-accent/10 px-2 py-1 rounded" data-id="element-111">
                    Next step
                  </span>
                </div>

                <div className="flex items-center justify-between p-4 bg-white rounded-lg border border-gray-100 opacity-75" data-id="element-112">
                  <div className="flex items-center" data-id="element-113">
                    <div className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center mr-4" data-id="element-114">
                      <span className="text-gray-500 font-bold text-sm" data-id="element-115">2</span>
                    </div>
                    <div data-id="element-116">
                      <div className="font-bold text-navy" data-id="element-117">
                        25% payment (£450)
                      </div>
                      <div className="text-sm text-gray-500" data-id="element-118">
                        Due upon logo approval
                      </div>
                    </div>
                  </div>
                </div>

                <div className="flex items-center justify-between p-4 bg-white rounded-lg border border-gray-100 opacity-75" data-id="element-119">
                  <div className="flex items-center" data-id="element-120">
                    <div className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center mr-4" data-id="element-121">
                      <span className="text-gray-500 font-bold text-sm" data-id="element-122">3</span>
                    </div>
                    <div data-id="element-123">
                      <div className="font-bold text-navy" data-id="element-124">
                        50% final balance (£900)
                      </div>
                      <div className="text-sm text-gray-500" data-id="element-125">
                        Due upon final delivery
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mt-10" data-id="element-126">
                <button onClick={() => setShowBankDetails(!showBankDetails)} className="flex items-center text-sm font-medium text-gray-500 hover:text-navy transition-colors" data-id="element-127">
                  <CreditCardIcon className="w-4 h-4 mr-2" data-id="element-128" />
                  {showBankDetails ? 'Hide bank details' : 'Show bank details for transfer'}
                  <ChevronDownIcon className={`w-4 h-4 ml-1 transition-transform ${showBankDetails ? 'rotate-180' : ''}`} data-id="element-129" />
                </button>

                <AnimatePresence data-id="element-130">
                  {showBankDetails && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} className="overflow-hidden" data-id="element-131">
                      <div className="mt-4 p-6 bg-navy text-white rounded-xl" data-id="element-132">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm" data-id="element-133">
                          <div data-id="element-134">
                            <span className="block text-gray-400 text-xs mb-1" data-id="element-135">
                              Bank
                            </span>
                            <span className="font-medium" data-id="element-136">Clearbank</span>
                          </div>
                          <div data-id="element-137">
                            <span className="block text-gray-400 text-xs mb-1" data-id="element-138">
                              Account name
                            </span>
                            <span className="font-medium" data-id="element-139">
                              AVY Consultancy Limited
                            </span>
                          </div>
                          <div data-id="element-140">
                            <span className="block text-gray-400 text-xs mb-1" data-id="element-141">
                              Company number
                            </span>
                            <span className="font-medium" data-id="element-142">12143361</span>
                          </div>
                          <div data-id="element-143">
                            <span className="block text-gray-400 text-xs mb-1" data-id="element-144">
                              Sort code
                            </span>
                            <span className="font-mono" data-id="element-145">04-06-05</span>
                          </div>
                          <div data-id="element-146">
                            <span className="block text-gray-400 text-xs mb-1" data-id="element-147">
                              Account no
                            </span>
                            <span className="font-mono" data-id="element-148">16926743</span>
                          </div>
                          <div data-id="element-149">
                            <span className="block text-gray-400 text-xs mb-1" data-id="element-150">
                              Reference
                            </span>
                            <span className="font-mono text-accent" data-id="element-151">
                              NEWCO-MVB-2026
                            </span>
                          </div>
                        </div>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </div>
          </div>
        </ScrollReveal>
      </div>
    </section>;
}